<template>
  <CorseProjectsManageModule ctitle="" :isAdmin="3" />
</template>
<script>
import CorseProjectsManageModule from "./corseProjectsManageModule";
export default {
  components: {
    CorseProjectsManageModule
  },
}
</script>
